import type { FieldUnitSpec } from "lab-testing-units";

// Canonicals restate what today's bare numbers already mean; they are frozen, never a choice.

// `switchable` is deliberately absent — the per-type tickets add a counterpart once they verify it.
export const SPECIMEN_DEPTH: FieldUnitSpec = { quantity: "length", canonical: "m", dp: 2 };

// One spec for the whole water-content mass set: it is a single group, so its members share a unit.
export const WATER_CONTENT_MASS: FieldUnitSpec = { quantity: "mass", canonical: "g", switchable: ["lb", "oz"], dp: 2 };
